
const state = {
  images: []
}

const getters = {
  images (state) {
    return state.images
  }
}

const actions = {
  setImages (context, params) {
    context.commit('SETIMAGES', params)
  }
}

const mutations = {
  SETIMAGES (state, params) {
    state.images = params
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/images.js